import { clientFetch } from "./clientFetch";

// Example: Specific service for events
export const UserService = {
  getAllUsers: (uidCompany:string) => 
    clientFetch(`/v1/users/${uidCompany}`,'GET'),
  getUsersByIds: (uidCompany:string,uids:string[],key:string) => 
    clientFetch(`/v1/users`,'POST',key,{ body:{company:uidCompany,users:uids}}),
  getPermissions: (uidCompany:string,uidUser:string) => 
    clientFetch(`/v1/user/${uidUser}/company/${uidCompany}/permissions`,'GET'),
  updatePermissions: (uidCompany:string, uid:string, key:string, permissions:{views:string[],actions:string[]})=>
    clientFetch(`/v1/user/${uid}/company/${uidCompany}/permissions`,'PUT',key,{ body:{...permissions}}),
  searchBulkUsers: (search: string, company: string, key: string) =>
    clientFetch('/v1/users/search', 'POST', key, { body: { company, search } }),
};
